export default __webpack_public_path__ + "static/media/img_landing1.e849448c.png";